:host(.active) {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: $z-index-offcanvas;

  .slide {
    display: inline-block;
    position: absolute;
    height: 100%;
    transition: transform 0.3s;
    transition-delay: 0.1s;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 45%);
    overflow: auto;
    overflow-x: hidden;
    touch-action: pan-y;
    top: 0;

    &.left {
      left: 0;
      transform: translateX(-100%);
    }

    &.right {
      right: 0;
      transform: translateX(100%);
    }

    @include breakpoint($desktop) {
      width: auto;
    }
  }

  .background {
    transition: opacity 0.4s;
    background-color: transparent;
    width: 100vw;
    height: 100vh;
    opacity: 0;

    &.darken {
      background-color: rgb(0 0 0 / 50%);
    }
  }
}

:host(.active.open) {
  pointer-events: all;

  .slide {
    transform: translateX(0%);
  }

  .background {
    opacity: 1;
  }
}
